import React, {ReactNode} from 'react';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ConversationBaseModel} from '../../../../../../models/api/conversationModel';
import {SafetyNetActionsEnum} from '../safetyNetsContext';

interface RequiredTaggingLabel {
  okButton: ReactNode;
  renderDescription: (conversation?: ConversationBaseModel) => ReactNode;
}

export const requiredTaggingLabels: Partial<Record<SafetyNetActionsEnum, RequiredTaggingLabel>> = {
  [SafetyNetActionsEnum.MOVE]: {
    okButton: <Trans id="required-tagging-dialog-ok-move">Tag & Move</Trans>,
    renderDescription(conversation) {
      if (conversation) {
        return (
          <Trans id="required-tagging-dialog-content-bulk-move">
            Your conversation {renderBulkConversationName(conversation)} requires tagging. Please select tags
            for this conversation before attempting any bulk moving.
          </Trans>
        );
      }

      return (
        <Trans id="required-tagging-dialog-content-move">
          Please select tags from the lists below before moving.
        </Trans>
      );
    },
  },
  [SafetyNetActionsEnum.ARCHIVE]: {
    okButton: <Trans id="required-tagging-dialog-ok-archive">Tag & Archive</Trans>,
    renderDescription(conversation) {
      if (conversation) {
        return (
          <Trans id="required-tagging-dialog-content-bulk-archive">
            Your conversation {renderBulkConversationName(conversation)} requires tagging. Please select tags
            for this conversation before attempting any bulk archiving.
          </Trans>
        );
      }

      return (
        <Trans id="required-tagging-dialog-content-archive">
          Please select tags from the lists below before archiving.
        </Trans>
      );
    },
  },
  [SafetyNetActionsEnum.SEND_AND_ARCHIVE]: {
    okButton: <Trans id="required-tagging-dialog-ok-send-and-archive">Tag & Archive</Trans>,
    renderDescription(conversation) {
      if (conversation) {
        return (
          <Trans id="required-tagging-dialog-content-bulk-send-and-archive">
            Your conversation {renderBulkConversationName(conversation)} requires tagging. Please select tags
            for this conversation before attempting any bulk archiving.
          </Trans>
        );
      }

      return (
        <Trans id="required-tagging-dialog-content-send-and-archive">
          Please select tags from the lists below before archiving.
        </Trans>
      );
    },
  },
  [SafetyNetActionsEnum.COMMENT_AND_ARCHIVE]: {
    okButton: <Trans id="required-tagging-dialog-ok-comment-and-archive">Comment & Archive</Trans>,
    renderDescription(conversation) {
      if (conversation) {
        return (
          <Trans id="required-tagging-dialog-content-bulk-comment-and-archive">
            Your conversation {renderBulkConversationName(conversation)} requires tagging. Please select tags
            for this conversation before attempting any bulk archiving.
          </Trans>
        );
      }

      return (
        <Trans id="required-tagging-dialog-content-comment-and-archive">
          Please select tags from the lists below before archiving.
        </Trans>
      );
    },
  },
} as const;

function renderBulkConversationName(conversation: ConversationBaseModel) {
  const recipientText = conversation.recipient?.name ? (
    <>
      with <b>{conversation.recipient.name}</b>
    </>
  ) : null;
  return (
    <>
      {recipientText} <b>“{conversation.subject}”</b>
    </>
  );
}
